import styled from 'styled-components';

import { BaseStyle } from '@nhl/nhl-breakaway-ui';

export const HomeContainer = styled.main`
    padding: 0 16px;

    ${BaseStyle.Mixins.screenSizes.large} {
        padding: 0 24px;
    }
`;
